import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as display from '../../../../display'
import * as componentStore from '../component-store'

/**
 * Displays a question component depending on it's type
 */
@ngCore.Component({
  imports: [display.field.Component],
  selector: 'atn-widget-fields',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link componentStore.FieldCollectionStore}  */
  private readonly _widgetStore = ngCore.inject(componentStore.Widget)
  /**
   * Question to be displayed
   *
   * @see {@link ents.core.mosaic.Widget.Rendering}
   */
  public readonly fieldsSg = ngCore.input<
    readonly ents.core.display.Field[],
    readonly ents.core.display.Field[] | undefined
  >([], {
    alias: 'fields',
    transform: fields => fields ?? [],
  })

  /**
   * Max number of columns that should be presented
   */
  public readonly columnCountSg = ngCore.input<number | undefined>(1, {
    alias: 'columnCount',
  })

  /**
   * If defined, fields will be rendered inside an ordered list (<ol>) starting from this index.
   *
   * @example
   * // startFrom = 1 → <ol start="1"><li>Field A</li>...</ol>
   */
  public readonly startFromSg = ngCore.input<number | undefined>(1, {
    alias: 'startFrom',
  })

  /**
   * Whether fields should be visually ordered using an <ol> element.
   */
  public readonly isOrderedSg = ngCore.input<boolean>(false, {
    alias: 'isOrdered',
  })

  constructor() {
    // NOTE: Initialize field collection values early to ensure correct values
    // are available for DMS mutations, preventing null/undefined values, when
    // fields are not touched.
    ngCore.effect(() => {
      const fields = this.fieldsSg()
      for (const { id, value } of fields) {
        if (id) {
          this._widgetStore.fieldCollection.setFieldValue(id, value)
        }
      }
    })
  }

  /**
   * Setting field value in field collection upon field value change so that it
   * could be accessed upon editing/creating new entity through details
   */
  public fieldValueChangeHandler(
    value: unknown,
    /**
     * NOTE: id parameter is optional to support {@link ents.core.display.Field.readonly}
     * fields, which may not require an id when displayed in readonly mode
     */
    id?: ents.core.display.Field.Id,
  ) {
    // check for undefined explicitly to handle falsy values correctly
    if (id !== undefined) {
      this._widgetStore.fieldCollection.setFieldValue(id, value)
    }
  }
}
